import React, { useEffect, useState } from 'react';
import {
  FormControl, InputLabel, MenuItem,
  Select, SelectProps,
} from '@mui/material';
import { IProps } from './interfaces';
import {
  SelectedAssetItem,
  SelectedAssetsContainer,
  SelectedAssetsInfoText,
  SelectedAssetsItemList,
  SelectedAssetText,
} from './styles';

const selectProps: SelectProps = {
  MenuProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  },
};

const SelectedAssetsInfo: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    selectedAssets,
    action,
    renditions,
    renditionsMap,
    unPublishableAssets,
    handleSelectRendition,
  } = props;

  if (!selectedAssets) return null;
  let publishing = true;
  if (action) publishing = false;

  return (
    <SelectedAssetsContainer>
      <SelectedAssetsInfoText>
        {action || 'Publishing'} {selectedAssets.length} Items
      </SelectedAssetsInfoText>
      <SelectedAssetsItemList>
        {publishing ? selectedAssets.map((s) => (
          <SelectedAssetItem>
            <SelectedAssetText className={unPublishableAssets.includes(s._id) ? 'unPublishable' : ''} key={s._id}>{s._source.title}</SelectedAssetText>
            {renditionsMap && (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="statusLabel">Rendition</InputLabel>
                <Select
                  {...selectProps}
                  labelId="statusLabel"
                  id="status"
                  onChange={(e: any) => handleSelectRendition(s._id, e.target.value)}
                  value={renditionsMap.has(s._id) ? renditionsMap.get(s._id) : ''}
                  label="Rendition"
                  disabled={renditions?.size === 0 || renditions.get(s._id)?.length === 0}
                >
                  {renditions && renditions.get(s._id)?.map((rendition) => (
                    <MenuItem value={rendition.type}>
                      <em>{rendition.label} {rendition.fileFormat}</em>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </SelectedAssetItem>
        ))
          : selectedAssets.map((s) => <SelectedAssetText key={s._id}>{s._source.title}</SelectedAssetText>)}
      </SelectedAssetsItemList>
    </SelectedAssetsContainer>
  );
};

export default SelectedAssetsInfo;
